import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder, faEllipsisV } from "@fortawesome/free-solid-svg-icons";

/**
 * <Folder folder={}
 *    tzOpts={}
 *    handleOpenFolder={}
 *    handleOpenContextMenu={}
 *    editMode={}
 *  />
 **/
const Folder = (props) => {
  let { method, user, timestamp } = props.folder.activity;
  let localeTimeStamp = new Date(timestamp).toLocaleString(
    "en-US",
    props.tzOpts
  );
  const contextMenuBtn = props.editMode ? (
    <button
      className="btn alert-secondary"
      type="button"
      data-toggle="collapse"
      data-target={`#folder${props.folder.id}MenuToggle`}
      aria-controls={`#folder${props.folder.id}MenuToggle`}
      aria-expanded="false"
      aria-label="Toggle navigation"
      onClick={(event) => {
        props.handleOpenContextMenu(
          props.folder.id,
          "folder",
          props.folder.name,
          null /**no url for folders**/,
          event
        );
      }}
    >
      <FontAwesomeIcon icon={faEllipsisV} color="grey" size="lg" />
    </button>
  ) : (
    ""
  );
  return (
    <li
      className="list-group-item list-group-item-action d-flex justify-content-between"
      onClick={() => {
        props.handleOpenFolder(props.folder.id);
      }}
      onContextMenu={(event) => {
        if (props.editMode) {
          props.handleOpenContextMenu(
            props.folder.id,
            "folder",
            props.folder.name,
            null /**no url for folders**/,
            event
          );
        }
      }}
    >
      <div className="folder-name inner-buffer">
        <span className="fa fa-folder pr-1"></span>
        <FontAwesomeIcon icon={faFolder} size="lg" color="lightblue" />
        <span className="pl-1">
          <strong>{props.folder.name}</strong>
        </span>
      </div>
      <div className="folder-timestamp inner-buffer text-muted">
        {method} by {user} <em>({localeTimeStamp})</em>
      </div>
      {contextMenuBtn}
    </li>
  );
};

export default Folder;
